module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Bold.ttf?v=65acb0afcd87409551f824a637cb4490";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Bold.ttf
// module id = 642
// module chunks = 0